import DoneIcon from '@mui/icons-material/Done';
import { Box, useTheme } from '@mui/material';

/**
 * Оранжевый круг с иконкой галочки
 */
export const DoneCircle = () => {
  const { palette } = useTheme();

  return (
    <Box
      bgcolor={palette.secondary.main}
      width={24}
      height={24}
      borderRadius='50%'
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <DoneIcon sx={{ color: palette.common.white, width: 20, height: 20 }} />
    </Box>
  );
};
